import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const testimonials = [
  {
    quote:
      'I am deeply grateful, Yogeshbhai, and you are family to me. Whatever and whenever you need anything, you can count on me. Again, thanks for a magnificent execution.',
    name: 'Mukesh Ambani',
    location: 'Chairman, Reliance Industries',
  },
  {
    quote:
      'One of the most talented designers in the world. Great meeting you.',
    name: 'Preston Bailey',
    location: 'World-Renowned Event Designer · New York',
  },
  {
    quote:
      'YPD crafted a wedding that felt like poetry. Every moment was curated with love and luxury — our guests still talk about it!',
    name: 'Ananya & Raghav',
    location: 'Udaipur · Palace Courtyard',
  },
  {
    quote:
      'From logistics to design, their team was flawless. The sunset vows by the sea were the stuff of dreams.',
    name: 'Mira & Jay',
    location: 'Goa · Beachfront Estate',
  },
  {
    quote:
      'They brought Rajasthan’s soul to life. Sangeet under the stars, artisans on site — it was an immersive celebration.',
    name: 'Zoya & Aarav',
    location: 'Jaisalmer · Desert Oasis',
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (hovered) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [hovered]);

  const prev = () => setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  const next = () => setIndex((prev) => (prev + 1) % testimonials.length);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50" id="testimonials">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.4em] text-[#395958] mb-3">Voices of YPD Weddings</div>
          <h3 className="text-3xl md:text-4xl font-serif text-black mb-4">Client Testimonials</h3>
          <p className="text-sm text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Thoughtfully orchestrated celebrations — told through the words of those who lived them.
          </p>
        </div>

        <div
          className="relative max-w-3xl mx-auto bg-white border border-gray-200 rounded-lg shadow-sm"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <div className="absolute -top-5 left-6 w-10 h-10 bg-[#F1D291] rounded-full flex items-center justify-center shadow-md">
            <Quote className="w-5 h-5 text-[#395958]" />
          </div>

          <div className="px-6 md:px-10 py-10">
            <AnimatePresence mode="wait">
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.5 }}
                className="text-center"
              >
                <p className="text-2xl md:text-3xl font-serif italic text-gray-800 leading-relaxed mb-8">
                  “{testimonials[index].quote}”
                </p>
                <div className="flex items-center justify-center gap-3">
                  <span className="text-sm font-medium text-gray-900">{testimonials[index].name}</span>
                  {testimonials[index].location && (
                    <span className="text-xs uppercase tracking-[0.25em] text-[#395958]">{testimonials[index].location}</span>
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="absolute inset-x-0 -bottom-5 flex items-center justify-center gap-3">
            <button
              onClick={prev}
              aria-label="Previous testimonial"
              className="w-10 h-10 rounded-full border border-gray-300 bg-white text-[#395958] hover:border-[#395958] hover:bg-[#F1D291]/30 flex items-center justify-center shadow-sm"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={next}
              aria-label="Next testimonial"
              className="w-10 h-10 rounded-full border border-gray-300 bg-white text-[#395958] hover:border-[#395958] hover:bg-[#F1D291]/30 flex items-center justify-center shadow-sm"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

          <div className="mt-10 pb-6 flex items-center justify-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                aria-label={`Go to testimonial ${i + 1}`}
                onClick={() => setIndex(i)}
                className={`w-2.5 h-2.5 rounded-full ${i === index ? 'bg-[#395958]' : 'bg-gray-300'} transition-colors`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
